import { Container, Row, Col, Button } from "react-bootstrap";

import VehicleFilters from "../../components/manageVehicle/VehicleFilters";
import VehicleTable from "../../components/manageVehicle/VehicleTable";
import StatsCard from "../../components/dashboard/StatsCard";
import { BsCarFront } from "react-icons/bs";
import { FaCheck } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { useEffect, useState } from "react";
import { AddVehicle } from "../../components/reserve/AddVehicle";
import { getMyVehicles } from "../../services/Networkcall";
import { errorAlert } from "../../components/common/Alert";

export default function ManageVehicles() {
    const [showAddVehicleModal, setshowAddVehicleModal] = useState(false);
    const [vehicleData, setVehicleData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [analyticsData, setAnalyticsData] = useState({ total: 0, active: 0, inactive: 0 });

     //   ===========VEHICLES LIST====================
        const fetchMyVehicles = async () => {
            setLoading(true);
            try {
                const res = await getMyVehicles();
                if (res?.success) {
                    setVehicleData(res?.data);
                    const total = res?.data?.length || 0;
                    const active = res?.data?.filter((v) => v?.status === "ACTIVE")?.length || 0;
                    const inactive = res?.data?.filter((v) => v?.status === "INACTIVE")?.length || 0;
                    setAnalyticsData({ total, active, inactive });
                } else {
                    errorAlert({ message: res?.message });
                }
            } catch (err) {
               errorAlert({message: err?.response?.data?.message || err?.message ||  "somethinng went wrong" });
            } finally {
                setLoading(false);
            }
        };
    
    
     //   ===========EFFECTS====================
        useEffect(() => {
            fetchMyVehicles();
        }, []);
    
    

    return (
        <Container fluid className="mv-page vh-100 overflow-scroll">

            {/* HEADER */}
            <div className="mv-header">
                <div>
                    <h3>Manage Vehicles</h3>
                    <p>View, search and manage all vehicles in your fleet.</p>
                </div>

                <Button className="mv-add-btn" onClick={()=>setshowAddVehicleModal(true)}>+ Add Vehicle</Button>
            </div>

            <Row className="g-2">
                <Col md={4}>
                    <StatsCard
                        title="Total Vehicle"
                        value={analyticsData.total}
                        subtitle={'All vehicles in fleet'}
                        color="#1976d2"
                        bgColor="#e3f2fd"
                        icon={BsCarFront} 
                        iconSize={30}
                        className="mt-0"
                        />
                </Col>
                <Col md={4}>
                    <StatsCard
                        title="Active"
                        value={analyticsData.active}
                        subtitle={`${(analyticsData.active/analyticsData.total * 100).toFixed(1)}% of Total`}
                        color="#0bb41c"
                        bgColor="#eeffec"
                        icon={FaCheck} 
                        iconSize={30}
                        className="mt-0"
                        />
                </Col>
                <Col md={4}>
                    <StatsCard
                        title="Inactive"
                        value={analyticsData.inactive}
                        subtitle={`${(analyticsData.inactive/analyticsData.total * 100).toFixed(1)}% of Total`}
                        color="#d21919"
                        bgColor="#ffe9e9"
                        icon={IoClose} 
                        iconSize={30}
                        className="mt-0"
                        />
                </Col>
            </Row>

           

            {/* TABLE */}
            <VehicleTable vehicleData={vehicleData} loading={loading} setLoading={setLoading} fetchMyVehicles={fetchMyVehicles} />

            {showAddVehicleModal && <AddVehicle  show={showAddVehicleModal} closeModal={()=>setshowAddVehicleModal(false)}/>}

        </Container>
    );
}